import { render, staticRenderFns } from "./CardPropertyString.vue?vue&type=template&id=ae92cace&scoped=true&"
import script from "./CardPropertyString.vue?vue&type=script&lang=js&"
export * from "./CardPropertyString.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyString.vue?vue&type=style&index=0&id=ae92cace&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae92cace",
  null
  
)

export default component.exports
import {QInput,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QTooltip}, component.options.components || {})
